import type { AppAccessPolicy } from './types';

export function normalizeBundleId(bundleId: string): string {
  return bundleId.toLowerCase();
}

export function appAccessEvaluator(
  policy: AppAccessPolicy
): (bundleId: string | null | undefined) => boolean {
  const excluded = new Set(policy.excludedBundleIds.map(normalizeBundleId));
  const allowed = new Set(policy.allowedBundleIds.map(normalizeBundleId));
  return (bundleId) => {
    if (bundleId == null) return policy.appAccessMode === 'allow';
    const normalized = normalizeBundleId(bundleId);
    return (
      excluded.has(normalized) ||
      (policy.appAccessMode === 'allow' && !allowed.has(normalized))
    );
  };
}
